module.exports = __webpack_public_path__ + "static/img/个人数字业务.cb9d36a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/个人数字业务.png
// module id = /sj5
// module chunks = 0